(() => {
  if (customElements.get('ffn-product-information')) return;

  customElements.define(
    'ffn-product-information',
    class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-ffn-info-dialog]');
        this.titleElement = this.querySelector('[data-ffn-info-title]');
        this.triggers = [...this.querySelectorAll('[data-ffn-info-open]')];
        this.panels = [...this.querySelectorAll('[data-ffn-info-panel]')];
        this.closeButton = this.querySelector('[data-ffn-info-close]');
        if (!this.dialog || !this.triggers.length) return;

        this.triggers.forEach((trigger) =>
          trigger.addEventListener('click', () => this.openDrawer(trigger))
        );
        this.closeButton?.addEventListener('click', () => this.closeDrawer());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeDrawer();
        });
        this.dialog.addEventListener('close', () => {
          this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
          this.activeTrigger?.focus();
        });
      }

      openDrawer(trigger) {
        const key = trigger.dataset.ffnInfoOpen;
        const activePanel = this.panels.find((panel) => panel.dataset.ffnInfoPanel === key);
        if (!activePanel) return;

        this.activeTrigger = trigger;
        this.triggers.forEach((item) =>
          item.setAttribute('aria-expanded', item === trigger ? 'true' : 'false')
        );
        this.panels.forEach((panel) => {
          panel.hidden = panel !== activePanel;
        });
        const label = trigger.querySelector(':scope > span:nth-child(2)');
        if (this.titleElement && label) this.titleElement.textContent = label.textContent.trim();

        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        requestAnimationFrame(() => this.closeButton?.focus());
      }

      closeDrawer() {
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else {
          this.dialog.removeAttribute('open');
          this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
          this.activeTrigger?.focus();
        }
      }
    }
  );
})();
